<template>
  <v-container fluid>
    <v-row justify="start" class="mission-page">
      <input-block
        class="mission"
        :modules="mission"
        title="Миссия и превью"
        :options="{ tabs: true }"
      />
      <input-block
        class="mission"
        :modules="values"
        title="Ценности"
        :options="{ tabs: true }"
      />
    </v-row>
  </v-container>
</template>

<script>
import InputBlock from "../InputBlock/InputBlock";

const minToolbar = [["bold", "italic", "underline"], ["link"]];

export default {
  name: "MissionPage",
  components: { InputBlock },
  data() {
    return {
      mission: {
        mission: {
          image: {
            type: "image",
            langs: ["all"],
            hint: "1439 × 400 px"
          },
          subheader: {
            type: "subheader",
            langs: ["ru", "kk", "en"],
            label: "Миссия"
          },
          mission: {
            type: "textHtml",
            langs: ["ru", "kk", "en"],
            toolbar: minToolbar,
            label: "",
            maxHeight: 200
          }
        }
      },
      values: {
        mission: {
          people: {
            type: "text",
            langs: ["ru", "kk", "en"],
            toolbar: minToolbar,
            label: "Люди",
            maxHeight: 300
          },
          safety: {
            type: "text",
            langs: ["ru", "kk", "en"],
            toolbar: minToolbar,
            label: "Безопасность",
            maxHeight: 300
          },
          improvement: {
            type: "text",
            langs: ["ru", "kk", "en"],
            toolbar: minToolbar,
            label: "Непрерывное развитие и совершенствование",
            maxHeight: 300
          },
          ethics: {
            type: "text",
            langs: ["ru", "kk", "en"],
            toolbar: minToolbar,
            label: "Этичность, прозрачность, ответственность",
            maxHeight: 300
          }
        }
      }
    };
  }
};
</script>
<style lang="scss">
.mission-page {
  gap: 24px;
  align-items: flex-start;
  .textCard {
    min-width: 400px;
    flex: 1;
  }
  .textCard.mission {
    .v-textarea {
      padding-top: 16px;
      textarea {
        font-size: 14px;
        line-height: 1;
      }
      .v-label--active {
        transform: translateY(-26px) scale(0.85);
        font-weight: 500;
        color: #1a237e;
      }
    }
  }
}
</style>
